import { required, email, numeric } from '@vee-validate/rules'
import { configure, defineRule } from 'vee-validate'

import type { AppI18n } from '@/plugins/i18n'

export const init = (i18n: AppI18n) => {
  configure({
    bails: false,
    generateMessage: (context) =>
      i18n.global.t(`validation.${context.rule?.name}`, { value: context.value }),
  })

  const withTrim = (rule: (value: unknown) => boolean | string) => (value: unknown) => {
    if (value == null || value === '') {
      return true
    }
    return rule(typeof value === 'string' ? value.trim() : value)
  }

  defineRule('required', required)
  defineRule('email', withTrim(email))
  defineRule('numeric', withTrim(numeric))
}
